// extracted by mini-css-extract-plugin
export default {"main__body":"MainPage_main__body__nKQpt","image":"MainPage_image__2whLx","bottom__text":"MainPage_bottom__text__5VGm9","button":"MainPage_button__YyV+y"};